var render = function () {
var _obj, _obj$1, _obj$2, _obj$3, _obj$4;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pagination.pageCount > 1)?_c('div',{staticClass:"t-pagination"},[_c(_vm.prevTag,{tag:"component",staticClass:"t-pagination__prev",class:{ _disabled: !_vm.prevActive },attrs:{"to":{
      path: _vm.$route.path,
      query: Object.assign(
        {},
        _vm.$route.query,
        _vm.deleteLoadMore,
        ( _obj = {}, _obj[_vm.nameCurrentPage] = _vm.pagination.currentPage - 1, _obj ),
        { animation: _vm.animation }
      ),
    }}},[_c('svg',{attrs:{"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.48561 7L7.61523 0.870379L6.74486 0L0.180046 6.56481C-0.0603032 6.80516 -0.0603032 7.19484 0.180046 7.43519L6.74486 14L7.61523 13.1296L1.48561 7Z","fill":"#C8C8C8"}})])]),_vm._v(" "),_c('div',{staticClass:"t-pagination-list"},[(_vm.dots && _vm.pagination.pageCount > _vm.max + 2 && _vm.pagination.currentPage > 3)?_c('router-link',{staticClass:"t-pagination-list__link",attrs:{"to":{
        path: _vm.$route.path,
        query: Object.assign({}, _vm.$route.query, _vm.deleteLoadMore, ( _obj$1 = {}, _obj$1[_vm.nameCurrentPage] = _vm.range[0].i - 1, _obj$1 ), { animation: _vm.animation }),
      }}},[_vm._v("\n      ...\n    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.range),function(item){
      var _obj;
return [_c('router-link',{key:item.i,staticClass:" t-pagination__item",class:{ 't-pagination__item_active': item.i === _vm.currentPage },attrs:{"to":{
          path: _vm.$route.path,
          query: Object.assign({}, _vm.$route.query, _vm.deleteLoadMore, ( _obj = {}, _obj[_vm.nameCurrentPage] = item.i, _obj ), { animation: _vm.animation }),
        }}},[_vm._v("\n        "+_vm._s(item.i)+"\n      ")])]}),_vm._v(" "),(_vm.dots && _vm.pagination.pageCount > _vm.max + 2 && _vm.pagination.currentPage < _vm.pagination.pageCount - 3)?_c('router-link',{staticClass:"t-pagination-list__link",attrs:{"to":{
        path: _vm.$route.path,
        query: Object.assign(
          {},
          _vm.$route.query,
          _vm.deleteLoadMore,
          ( _obj$2 = {}, _obj$2[_vm.nameCurrentPage] = _vm.range[_vm.range.length - 1].i + 1, _obj$2 ),
          { animation: _vm.animation }
        ),
      }}},[_vm._v("\n      ...\n    ")]):_vm._e(),_vm._v(" "),(_vm.dots && _vm.pagination.pageCount > _vm.max + 2 && _vm.pagination.currentPage < _vm.pagination.pageCount - 3)?_c('router-link',{staticClass:"t-pagination__item",class:{ 't-pagination__item_active': _vm.pagination.pageCount === _vm.pagination.currentPage },attrs:{"to":{
        path: _vm.$route.path,
        query: Object.assign(
          {},
          _vm.$route.query,
          _vm.deleteLoadMore,
          ( _obj$3 = {}, _obj$3[_vm.nameCurrentPage] = _vm.pagination.pageCount, _obj$3 ),
          { animation: _vm.animation }
        ),
      }}},[_vm._v("\n      "+_vm._s(_vm.pagination.pageCount)+"\n    ")]):_vm._e()],2),_vm._v(" "),_c(_vm.nextTag,{tag:"component",staticClass:"t-pagination__next",class:{ _disabled: !_vm.nextActive },attrs:{"to":{
      path: _vm.$route.path,
      query: Object.assign(
        {},
        _vm.$route.query,
        _vm.deleteLoadMore,
        ( _obj$4 = {}, _obj$4[_vm.nameCurrentPage] = _vm.pagination.currentPage + 1, _obj$4 ),
        { animation: _vm.animation }
      ),
    }}},[_c('svg',{attrs:{"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.51439 7L0.384766 0.870379L1.25514 0L7.81995 6.56481C8.0603 6.80516 8.0603 7.19484 7.81995 7.43519L1.25514 14L0.384766 13.1296L6.51439 7Z","fill":"#C8C8C8"}})])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/ui-components/pagination/pagination.vue?vue&type=template&id=3ceb9f56&
// module id = 1209
// module chunks = 0